import * as React from 'react'
import { ReactElement } from 'react'
import FormikField, { findValue, FormikSubFieldProps } from './FormikField'
import { Input } from '@fluentui/react-components'
import { InputProps } from '@fluentui/react-input'
import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'

export default function FormikInputField<Values>(props: FormikSubFieldProps<InputProps, Values>): ReactElement {
    const { t: translate } = useTranslation()
    const { values } = useFormikContext<Values>()

    const maxLength = props.componentProps?.maxLength
    const value = findValue(values, props.fieldName as string)

    // With a maxLength typing simply stops, which without a word of explanation reads as a broken keyboard. The
    // hint only appears once the limit is actually reached, and never over a hint the field asked for itself.
    const maxLengthHint =
        !props.hint && !props.hintKey && maxLength > 0 && typeof value === 'string' && value.length >= maxLength
            ? translate('base.field.maxlength', { count: maxLength })
            : undefined

    return <FormikField<InputProps, Values> component={Input} {...props} hint={props.hint ?? maxLengthHint} />
}
